import create from 'zustand';

type drmInformationSearchStore = {
  order: string;
  setOrder: ( order: string ) => void;
  pageSize: string;
  setPageSize: ( size: string ) => void;
  checkTypeCodes: string[];
  setCheckTypeCodes: ( ids: string[] ) => void;
  searchText: string;
  setSearchText: ( text: string ) => void;
  searchYear: string;
  setSearchYear: ( text: string ) => void;
  currentPage: number;
  setCurrentPage: ( page: number ) => void;
  backPage: string;
  setBackPage: ( backPage: string ) => void;
};

const useDrmInformationSearchStore = create<drmInformationSearchStore>(( set ) => ({
  order: "1",
  setOrder: ( order ) =>
    set(state => ({
      order: order,
    })),
  pageSize: "20",
  setPageSize: ( size ) =>
    set(state => ({
      pageSize: size
    })),
  checkTypeCodes: [],
  setCheckTypeCodes: ( ids ) =>
    set(state => ({
      checkTypeCodes: ids
    })),
  searchText: "",
  setSearchText: ( text ) =>
    set(state => ({
      searchText: text
    })),
  searchYear: "",
  setSearchYear: ( text ) =>
    set(state => ({
      searchYear: text
    })),
  currentPage: 0,
  setCurrentPage: ( page ) =>
    set(state => ({
      currentPage: page
    })),
  backPage: "/information",
  setBackPage: ( backPage ) =>
    set(state => ({
      backPage: backPage
    })),
}));

export function useDrmInformationSearch() {
  const state = useDrmInformationSearchStore();
  return {
    ...state,
  };
}